import { createSlice } from "@reduxjs/toolkit";
import {
  DATA_LOAD_STATUS,
  CHECKIN_PROCESS_TYPE,
  DOCUMENT_LOAD_STATUS,
} from "../../constants/metaData";
import { getPayloadValue } from "../../../functions/reduxMethod";

const initialState = {
  error: {},
  checkinNewStatus: "OnLoad",
  checkinDocumentProgress: DATA_LOAD_STATUS.onStart,
  checkinProgresseType: CHECKIN_PROCESS_TYPE.start,
  basicDataProgressType: DATA_LOAD_STATUS.onStart,
  checkinExistingStatus: DOCUMENT_LOAD_STATUS.onStart,
  checkinExistingData: {},
  checkinNewRevisionStatus: DOCUMENT_LOAD_STATUS.onStart,
  recentObjects: [],
  enableSpinner: false,
};

const checkInStatusSlice = createSlice({
  name: "checkin/checkInStatus",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("ON_CHECKIN_NEW_STATUS_CHANGED", (state, action) => {
        state.checkinNewStatus = action.payload;
      })
      .addCase("ON_CHECKIN_DOCUMENT_PROGRESS", (state, action) => {
        state.checkinDocumentProgress = action.payload;
      })
      .addCase("ON_CHECKIN_PROGRESS_CHANGED", (state, action) => {
        state.checkinProgresseType = action.payload;
      })
      .addCase("ON_BASIC_DATA_INFO_CHANGED", (state, action) => {
        state.basicDataProgressType = action.payload;
      })
      .addCase("ON_CHECKIN_EXISTING_STATUS_CHANGE", (state, action) => {
        state.checkinExistingStatus = getPayloadValue(
          action.payload,
          DOCUMENT_LOAD_STATUS.onStart
        );
      })
      .addCase("ON_CHECKIN_EXISTING_DATA_CHANGE", (state, action) => {
        state.checkinExistingData = getPayloadValue(action.payload, {});
      })
      .addCase("ON_CHECKIN_NEW_REVISION_STATUS_CHANGE", (state, action) => {
        state.checkinNewRevisionStatus = getPayloadValue(
          action.payload,
          DOCUMENT_LOAD_STATUS.onStart
        );
      })
      .addCase("ON_RECENT_OBJECT_VALUES", (state, action) => {
        state.recentObjects = action.payload;
        state.enableSpinner = action.payload?.state ?? false;
      })
      .addCase("ON_CHECKIN_DOC", (state, action) => {
        const p = action.payload;
        state.enableSpinner = p.state;
        state.error = p.error;
      });
  },
});

export default checkInStatusSlice.reducer;
